"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeConverter = void 0;
const VideosConverter_1 = require("../../../videos/model/VideosConverter");
const LinkEntity_1 = require("../../../common/model/LinkEntity");
class ThemeConverter {
    static convert(entity) {
        const { id, provider, title, topics, type, logoUrl, _links } = entity;
        const convertedTopics = topics?.map((topic) => {
            const { targets, ...rest } = topic;
            return {
                ...rest,
                targets: targets?.map((target) => {
                    const { videos, ...rest } = target;
                    return {
                        ...rest,
                        videos: videos?.map((video) => VideosConverter_1.VideosConverter.convert(video)),
                    };
                }),
            };
        });
        const convertLinks = {
            updateTheme: _links?.updateTheme
                ? new LinkEntity_1.Link(_links.updateTheme)
                : undefined,
            deleteThemeById: _links?.deleteThemeById
                ? new LinkEntity_1.Link(_links.deleteThemeById)
                : undefined,
        };
        return {
            id,
            provider,
            title,
            topics: convertedTopics,
            type: type,
            logoUrl,
            links: convertLinks,
        };
    }
}
exports.ThemeConverter = ThemeConverter;
//# sourceMappingURL=ThemeConverter.js.map